import { EventEmitter, Injectable } from '@angular/core';
import {NameUserAssignmentComponent } from '@app/shared';



@Injectable()
export class AssignationTaskService {

  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () { }

  /**
   * Retorna la configuracion de la tabla para los usuarios del grupo seleccionado
   *
   * @returns
   * @memberof AssignationTaskService
   */
  getSettingsTableAssignment() {
    const self = this;
    return  {
      mode: 'external',
      noDataMessage: 'No hay funcionarios registrados',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        // identificacion: {
        //   editable: false,
        //   addable: false,
        //   class: 'prueba',
        //   title: 'Identificación',
        //   filter: {
        //     inputClass: 'form-control',
        //   },
        // },
        nombre: {
          title: 'Nombre',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        apellidos: {
          title: 'Apellido',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        }
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/assignation-task/shared/assignation-task.config.service.ts